// @ts-nocheck
export default {
    SET_COORD_SELECT_MAP_DIALOG_OPEN(state, isOpen) {
        state.isCoordSelectMapDialogOpen = isOpen;
    },
};
